import { Tag } from 'antd';

import { COLUMN_TYPES } from '../Table/constants';

import { Location } from '../Location';
import EventName from '../TriggersList/component/EventName';
import { translateString } from '@src/util/intl/translateString';

export const TRIGGER_COLUMNS = [
  {
    key: 'event',
    title: translateString('general.event'),
    dataIndex: 'name',
    align: 'left',
    sortable: true,
    sortConfig: { type: COLUMN_TYPES.STRING },
    render: record => (
      <EventName
        eventName={record?.name}
        eventColor={record?.eventType?.color}
        eventIcon={record?.eventType?.icon}
      />
    ),
  },
  {
    key: 'location',
    title: translateString('general.locations'),
    dataIndex: 'location',
    align: 'left',
    sortable: true,
    sortConfig: { type: COLUMN_TYPES.NESTED, path: 'name' },
    render: record => {
      return record.locations.map(location => <Location location={location} type="primary" />);
    },
  },
  {
    key: 'status',
    title: translateString('general.status'),
    dataIndex: 'status',
    align: 'left',
    sortable: true,
    sortConfig: { type: COLUMN_TYPES.NESTED, path: 'label' },
    render: record => <Tag color={record?.status?.color}>{record?.status?.label}</Tag>,
  },
  {
    key: 'executions',
    title: translateString('general.executions'),
    dataIndex: 'executions',
    align: 'left',
    sortable: false,
  },
];
